<div class="modal-header border-0">
  <button type="button" class="btn-close" (click)="modal.dismiss()">
    <i class="gpicon-close"></i>
  </button>
</div>

<div class="custom-scroll-parent gpx-8">
  <div class="modal-body custom-scroll gpx-16 gpx-sm-64">
    <p class="p3-semibold modal-title w-100">
      {{ title | translate }}
    </p>
    <div class="row justify-content-start gpx-12">
      <div
        class="col-6 col-md-3 text-center gpx-12 gpt-24"
        *ngFor="let item of servings"
      >
        <img [src]="item.src" class="img-fluid" alt="serving" />
        <p class="p4-regular text-secondary">
          {{ item.translation | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
